export type LegalNoticeId = "datenschutz" | "impressum";

interface LegalNotice {
  /** Short label used in the header. */
  title: string;
  /** Document heading on the notice page. */
  pageTitle: string;
  path: string;
}

const legalNotices: Record<LegalNoticeId, LegalNotice> = {
  datenschutz: {
    title: "Datenschutz",
    pageTitle: "Datenschutzhinweise zur Intelligent Learning Platform",
    path: "/datenschutz",
  },
  impressum: {
    title: "Impressum",
    pageTitle: "Impressum",
    path: "/impressum",
  },
};

interface CourseLegalNoticeScope {
  enrollmentId?: string;
  courseExternalId?: string;
}

/**
 * Public path, or the same notice under the course already open.
 * Preview stays on the preview URL so the header keeps preview mode.
 */
const legalNoticePath = (
  noticeId: LegalNoticeId,
  scope: CourseLegalNoticeScope = {}
): string => {
  const { path } = legalNotices[noticeId];
  if (scope.courseExternalId) {
    return `/preview/${scope.courseExternalId}${path}`;
  }
  if (scope.enrollmentId) {
    return `/course/${scope.enrollmentId}${path}`;
  }
  return path;
};

const isScopedLegalNoticePath = (pathname: string, noticePath: string) =>
  (pathname.startsWith("/course/") || pathname.startsWith("/preview/")) &&
  pathname.endsWith(noticePath);

const isLegalNoticePath = (pathname: string): boolean =>
  Object.values(legalNotices).some(
    (notice) =>
      pathname === notice.path || isScopedLegalNoticePath(pathname, notice.path)
  );

const legalNoticePlaceholderParagraphs = [
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
  "Curabitur pretium tincidunt lacus. Nulla gravida orci a odio. Nullam varius, turpis et commodo pharetra, est eros bibendum elit, nec luctus magna felis sollicitudin mauris.",
];

export {
  isLegalNoticePath,
  legalNoticePath,
  legalNoticePlaceholderParagraphs,
  legalNotices,
};
